var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconVwrBlue = function SvgIconVwrBlue(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4A657B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.025 19.023h4.573c.434 0 .8-.367.8-.8V2.435c0-.434-.366-.8-.8-.8H2.637c-.434 0-.801.366-.801.8v15.82c0 .433.367.8.8.8H7.243c1.602-3.637 4.539-5.707 6.875-5.707 2.336 0 5.34 2.07 6.908 5.674zm6.976-16.587v15.82c0 1.301-1.068 2.402-2.403 2.402H17.12v2.437h3.537c.167 0 .3.133.3.3v.467c0 .167-.133.3-.3.3H7.576c-.167 0-.3-.133-.3-.3v-.5c0-.167.133-.3.3-.3h3.537v-2.437H2.637c-1.302 0-2.403-1.068-2.403-2.403V2.436C.234 1.101 1.302.033 2.637.033H25.63c1.302 0 2.37 1.068 2.37 2.403z",
    transform: "translate(-782 -298) translate(782 298)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.117 3.504c2.403 0 4.339 1.97 4.339 4.339 0 2.403-1.97 4.338-4.339 4.338-2.37 0-4.305-1.969-4.305-4.338 0-2.403 1.902-4.339 4.305-4.339z",
    transform: "translate(-782 -298) translate(782 298)"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconVwrBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-vwr-blue.af55a87ddb6ffea6176c5f9f6c97f2b6.svg";